const monthMap = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,
};

function buildDateQuery({ type, year, years, month, quarter, half }) {
  let query = {};

  if (type === "Monthly") {
    const monthNumber = monthMap[month];
    const startDate = new Date(year, monthNumber - 1, 1);
    const endDate = new Date(year, monthNumber, 0, 23, 59, 59, 999);
    query.date = { gte: startDate.toISOString(), lte: endDate.toISOString() };
  } else if (type === "Yearly") {
    const startDate = new Date(year, 0, 1);
    const endDate = new Date(year, 11, 31, 23, 59, 59, 999);
    query.date = { gte: startDate.toISOString(), lte: endDate.toISOString() };
  } else if (type === "Bi-Yearly") {
    const halves = {
      "1st Half": 1,
      "2nd Half": 2,
    };

    const halvesNumber = halves[half];
    const startMonth = (halvesNumber - 1) * 6;
    const endMonth = startMonth + 5;
    const startDate = new Date(year, startMonth, 1);
    const endDate = new Date(year, endMonth, 31, 23, 59, 59, 999);
    query.date = { gte: startDate.toISOString(), lte: endDate.toISOString() };
  } else if (type === "Quarterly") {
    const quarters = {
      "1st Quarter": 1,
      "2nd Quarter": 2,
      "3rd Quarter": 3,
      "4th Quarter": 4,
    };
    const quarterNumber = quarters[quarter];

    if (!quarterNumber) {
      throw new Error(
        `Invaldi value: ${quarter} , Expected Vlaue: "Q1","Q2","Q3" and "Q4"`,
      );
    }
    const startMonth = (quarterNumber - 1) * 3;
    const endMonth = startMonth + 2;
    const startDate = new Date(year, startMonth, 1);
    const endDate = new Date(year, endMonth + 1, 0, 23, 59, 59, 999);
    query.date = { gte: startDate.toISOString(), lte: endDate.toISOString() };
  }

  return query;
}

export default buildDateQuery;
